import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ModalBody } from 'reactstrap'

import { Modal, ModalHeader } from '../../generic'
import { closeAuth } from '../store/actions'
import {
  getFormTitle,
  getFormType,
  getVisible
} from '../store/selectors'

import AuthForms from './AuthForms'

const ModalAuth = () => {
  const dispatch = useDispatch()
  const visible = useSelector(getVisible)
  const title = useSelector(getFormTitle)
  const formType = useSelector(getFormType)

  const handleClose = useCallback(() => {
    dispatch(closeAuth())
  }, [dispatch])

  if (!visible) return null

  return (
    <Modal isOpen toggle={handleClose} backdrop fade className={`modal-auth modal-auth-${formType}`}>
      <ModalHeader onClose={handleClose}>{title}</ModalHeader>
      <ModalBody>
        <AuthForms />
      </ModalBody>
    </Modal>
  )
}

export default ModalAuth
